import { FormattedMessage } from 'react-intl';
import Icon from '../../../../../assets/icons/legacy/microphone_mute.svg';
export const MutedMicrophone = () => {
    return (<>
      <Icon />
      <FormattedMessage id="notification.microphone-muted{linebreak}" tagName="p" values={{
            linebreak: <br />,
        }}/>
    </>);
};
